<template>
	<div>
		<div id="id__header_in_order">
			<div class="mt-3">
				<div class="mb-4">
					<div
						v-b-toggle.collapse-education
					>
						<div class="d-flex justify-content-between align-items-center">
							<span class="documents-title mb-0 d-flex align-items-center">
								Образование
								<div class="education-info ml-2" @click="show = true">
									<i class="icon-info icon-icon_info" />
								</div>
							</span>
						</div>
					</div>
					<KeepAlive>
						<DocumentsEducation @changeNoEducation="$emit('changeNoEducation')" />
					</KeepAlive>
					<b-modal
						id="education-diploma-info"
						v-model="show"
						centered
					>
						<div>
							Согласно п. 3 ст. 107 Федерального закона «Об образовании в
							Российской Федерации» в нашей
							стране признаются иностранное образование и (или)
							иностранная квалификация, подпадающие под действие
							международных договоров о взаимном признании, а также полученные
							в иностранных образовательных организациях,
							перечень которых с указанием соответствия получаемых в них образования
							и (или) квалификации образованию и (или)
							квалификации, полученным в Российской Федерации, устанавливается
							Правительством Российской Федерации на основании Распоряжения
							Правительства РФ (актуальный перечень закреплен Распоряжением
							Правительства РФ от 30.01.2023 N 186-р)
						</div>
						<!-- <br> -->
						<!-- <div>
							Прилагаемый вами документ не соответствует выше указанным требованиям, следовательно, необходимо выбрать один из следующих вариантов:
						</div> -->
						<template #modal-footer>
							<div class="w-100">
								<b-button
									variant="primary"
									class="float-right"
									@click="show = false"
								>
									Закрыть
								</b-button>
							</div>
						</template>
					</b-modal>
				</div>

				<div class="mb-4">
					<div
						v-b-toggle.collapse-passport
					>
						<div class="d-flex justify-content-between align-items-center">
							<span class="documents-title mb-0">Паспорт</span>
						</div>
					</div>
					<KeepAlive>
						<DocumentsPassport />
					</KeepAlive>
				</div>

				<div class="mb-4">
					<div
						v-b-toggle.collapse-changing-fio
					>
						<div class="d-flex justify-content-between align-items-center">
							<span class="documents-title mb-0">Документ о смене ФИО</span>
						</div>
					</div>
					<KeepAlive>
						<DocumentChangeFIO />
					</KeepAlive>
				</div>

				<div>
					<div
						v-b-toggle.collapse-snils
					>
						<div class="d-flex justify-content-between align-items-center">
							<span class="documents-title mb-0">СНИЛС</span>
						</div>
					</div>
					<KeepAlive>
						<DocumentsSnils />
					</KeepAlive>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'PaymentDocuments',
	components: {
		DocumentsEducation: () => import('~/components/panels/formulate/components/documents/documentsEducation.vue'),
		DocumentsPassport: () => import('~/components/panels/formulate/components/documents/documentsPassport.vue'),
		DocumentChangeFIO: () => import('~/components/panels/formulate/components/documents/documentChangeFIO.vue'),
		DocumentsSnils: () => import('~/components/panels/formulate/components/documents/documentsSnils.vue'),
	},
	data() {
		return {
			show: false,
		};
	},
};
</script>

<style lang="scss" scoped>
@import "~/assets/styles/components/dev/order.scss";

.rotate-chevron {
	transform: rotate(180deg);
}

.documents-title {
	font-size: 1.2rem;
	font-weight: bold;
}

.education-info {
	cursor: pointer;
	width: 1.5rem;
    height: 1.5rem;
    font-size: 0.8rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
	padding: 0.2rem;
	background-color: #ACB5C7;
	color: white;

	.icon-icon_info {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 2px;
	}
}
</style>

<style lang="scss">
#education-diploma-info {
	.modal-header {
		border-bottom: none !important;
	}

	.modal-footer {
		border-top: none !important;
	}
}
</style>
